import { ReactComponent as SMEIcon } from 'assets/icons/SMEIcon.svg';

export const MySMEButton = (props) => {

  return (
    <SMEIcon/>
  )
}
